import React from 'react';
import PropTypes from 'prop-types';
import IconBase, { iconPropTypes } from '../IconBase';

export default function SortIcon({ sort, ...props }) {
	return (
		<IconBase type="sort" {...props}>
			<path
				d="M8,11L12,6L16,11Z"
				style={{ opacity: sort == 'ascending' ? 1 : 0.2 }}
			/>
			<path
				d="M8,13L12,18L16,13Z"
				style={{ opacity: sort == 'descending' ? 1 : 0.2 }}
			/>
		</IconBase>
	);
}

SortIcon.propTypes = {
	...iconPropTypes,
	sort: PropTypes.oneOf(['ascending', 'descending'])
};
